import { render, staticRenderFns } from "./PersonnelDashboardMembers.vue?vue&type=template&id=8bac4042&"
import script from "./PersonnelDashboardMembers.vue?vue&type=script&lang=js&"
export * from "./PersonnelDashboardMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports